import { API_BASE_URL } from "@/config";

export const MAIN_CONTROLLER = {
  data: () => ({
    current_service: null,
  }),
  mounted() {
    this.check_completion();
  },
  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    }
  },

  methods: {
  async check_service_completion(flex_name) {
    return new Promise((resolve) => {
      const TOKEN = localStorage.getItem('token');
      if (!TOKEN) {
        resolve({completed: false});
        return;
      }
      const BASE_URL = API_BASE_URL;
      const url = `${BASE_URL}/verify_api/customer_management_api/check_service_completion/?flex_name=${encodeURIComponent(flex_name)}&workflow_id=${this.workflow_id}`;
      $.ajax({
        url: url,
        method: 'GET',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        success: (response) => {
          resolve(response);
        },
        error: () => {
          resolve({completed: false});
        }
      });
    });
  },

  check_completion() {
    const flex_name = this.$route.name;
    this.check_service_completion(flex_name).then(response => {
      if (response.completed) {
        Swal.fire({
          title: 'Service Completed',
          text: 'This service has already been completed. Proceeding to the current service.',
          icon: 'info',
          confirmButtonText: 'OK'
        }).then(() => {
          this.fetch_current_service();
        });
      }
    });
  },
  async fetch_current_service(current_workflow_id=null) {

    var workflow_id = current_workflow_id || this.workflow_id;

    const TOKEN = localStorage.getItem('token');
    const asset_id = sessionStorage.getItem('asset_id');
    const BASE_URL = API_BASE_URL;
    const on_behalf_application = this.$route.name === 'behalf_application';
    let GET_CURRENT_SERVICE = `${BASE_URL}/verify_api/customer_management_api/workflow_main_controller/${workflow_id}`;

    if (asset_id && asset_id !== 'null') {
        GET_CURRENT_SERVICE += `?asset_id=${asset_id}`;
    }

    if (on_behalf_application) {
        GET_CURRENT_SERVICE += asset_id ? `&on_behalf=true` : `?on_behalf=true`;
    }
    
    $.ajax({
        url: GET_CURRENT_SERVICE,
        method: 'GET',
        contentType: 'application/json',
        headers: {
            Authorization: `Token ${TOKEN}`
        },
        success: (response) => {

            // Store entity_data_capture_config if present in the response
            if (response.entity_data_capture_config) {
              this.$store.commit('set_entity_data_capture_config', response.entity_data_capture_config);
            } else {
              this.$store.commit('clear_entity_data_capture_config');
            }

            if (this.$route.name === 'behalf_application') {
              this.$emit("service-completed", response);
              return;
            }

            // Loading handled internally - no need for Swal.close()
            let service_id = response.service_id;
            this.$store.commit('set_service_id', service_id);
            if (response.status == "Workflow completed") {
              // Custom thank you page takes priority
              if (response.has_custom_thank_you) {
                this.$router.push({ name: 'thank_you', params: { workflow_id: workflow_id } });
              } else {
                this.check_for_sub_workflows(workflow_id);
              }
            }
            else if (response.status == "Workflow completed anonymous") {
              // Custom thank you page takes priority
              if (response.has_custom_thank_you) {
                this.$router.push({ name: 'thank_you', params: { workflow_id: workflow_id } });
              } else {
                this.$router.push({ name: 'thank_you_page_anonymous' });
              }
            }
            else if (response.flex_name) {
              this.current_service = response.flex_name;
              this.route_to_current_service();
            }
            else if(response.service_name == "Address Details" && response.data && response.data.length > 0){
              this.$router.push({ name: 'address_details', params: { workflow_id: this.workflow_id } });
            }
            else if(response.service_name == "Qualifying Criteria" && response.data && response.data.length > 0){
              this.$router.push({ name: 'qualifying_criteria', params: { workflow_id: this.workflow_id } });
            }
            else if(response.service_name == "Employment Details" && response.data && response.data.length > 0){
              this.$router.push({ name: 'employment_details', params: { workflow_id: this.workflow_id } });
            }
            else if(response.service_name == "Marital Information" && response.data && response.data.length > 0){
              this.$router.push({ name: 'marital_information', params: { workflow_id: this.workflow_id } });
            }
            else if(response.service_name == "Personal Details" && response.data && response.data.length > 0){
              this.$router.push({ name: 'personal_details', params: { workflow_id: this.workflow_id } });
            }
            else if(response.service_name == "Salary Details" && response.data && response.data.length > 0){
              this.$router.push({ name: 'salary_details', params: { workflow_id: this.workflow_id } });
            }
            else {
              this.current_service = 'custom_service';
              this.route_to_current_service();
            }
        },
        error: () => {
        }
      });

  },

    check_for_sub_workflows(workflow_id) {
        const token = localStorage.getItem('token');
        const base_url = API_BASE_URL;
        const parent_workflow_id = localStorage.getItem('parent_workflow_id');
        const url = `${base_url}/verify_api/service_management_api/check_sub_workflows/?workflow_id=${workflow_id}`;

        

        fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Token ${token}`
          }
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === 'success') {
            let has_active_subworkflows = false;
            
           
            if (Array.isArray(data.data.sub_workflows)) {
              has_active_subworkflows = data.data.sub_workflows.some(workflow => workflow.is_active === true);
            }
            
          
            if (!has_active_subworkflows && Array.isArray(data.data.sub_external_workflows)) {
              has_active_subworkflows = data.data.sub_external_workflows.some(workflow => workflow.is_active === true);
            }
            
      
            if (parent_workflow_id) {

              Swal.fire({
                title: 'Workflow Complete',
                text: 'Would you like to view other available sub-workflows or return to the dashboard?',
                icon: 'success',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#28a745',
                confirmButtonText: 'Back to Sub-workflows',
                cancelButtonText: 'Go to Dashboard',
                reverseButtons: true
              }).then((result) => {
                if (result.isConfirmed) {

                  this.$store.dispatch('update_workflow_id', parent_workflow_id);


                  this.mark_workflow_complete(workflow_id);

                  this.$store.commit('clear_current_application');


                  this.$router.push({ name: 'sub_workflow_page' });
                } else {

                  this.$store.commit('clear_workflow_id');
                  this.$store.commit('clear_current_application');
                  localStorage.removeItem('parent_workflow_id');


                  this.$router.push('/assigned_workflows');
                }
              });
            } else if (has_active_subworkflows) {
              
              this.$router.push("/sub_workflow_page");
            } else {
          
              this.$router.push({ name: 'thank_you_page' });
            }
          } else {
           
            if (parent_workflow_id) {
              this.show_parent_workflow_dialog(parent_workflow_id, workflow_id);
            } else {
              this.$router.push({ name: 'thank_you_page' });
            }
          }
        })
        .catch(error => {
          console.error("Error checking for sub-workflows:", error);
          
          if (parent_workflow_id) {
            this.show_parent_workflow_dialog(parent_workflow_id, workflow_id);
          } else {
            this.$router.push({ name: 'thank_you_page' });
          }
        });
    },

   
    show_parent_workflow_dialog(parent_workflow_id, completed_workflow_id) {
      Swal.fire({
        title: 'Workflow Complete',
        text: 'Would you like to view other available sub-workflows or return to the dashboard?',
        icon: 'success',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#28a745',
        confirmButtonText: 'Back to Sub-workflows',
        cancelButtonText: 'Go to Dashboard',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
    
          this.$store.dispatch('update_workflow_id', parent_workflow_id);
          
       
          this.mark_workflow_complete(completed_workflow_id);
          
          this.$router.push({ name: 'sub_workflow_page' });
        } else {

          this.$store.commit('clear_workflow_id');
          this.$store.commit('clear_current_application');
          localStorage.removeItem('parent_workflow_id');
          this.$router.push('/');
        }
      });
    },

    
    mark_workflow_complete(workflowId) {
      
      const token = localStorage.getItem('token');
      const base_url = API_BASE_URL;
      
      $.ajax({
        method: 'GET',
        url: `${base_url}/verify_api/service_management_api/get_workflow_details/${workflowId}/`,
        headers: {
          Authorization: `Token ${token}`
        },
        success: (response) => {
          if (response.status === 'success') {
        
            if (!response.data.allow_multiple_onboarding) {
            
              let completedWorkflows = JSON.parse(localStorage.getItem('completed_workflows') || '[]');
              
          
              if (!completedWorkflows.includes(workflowId.toString())) {
                completedWorkflows.push(workflowId.toString());
                localStorage.setItem('completed_workflows', JSON.stringify(completedWorkflows));
              }
            }
          }
        },
        error: (xhr) => {
          console.error('Error fetching workflow details:', xhr);
        }
      });
    },


    handle_workflow_completion() {
        const token = localStorage.getItem('token');
        const base_url = API_BASE_URL;
        const workflow_id = this.workflow_id;
        const parent_workflow_id = localStorage.getItem('parent_workflow_id');
        

        $.ajax({
          method: 'POST',
          url: `${base_url}/verify_api/workflow_management_api/mark_workflow_complete/`,
          contentType: 'application/json',
          headers: {
            Authorization: `Token ${token}`
          },
          data: JSON.stringify({ 
            workflow_id: workflow_id 
          }),
          beforeSend: () => {
            Swal.fire({
              text: 'Finishing workflow...',
              allowEscapeKey: false,
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              }
            });
          },
          success: () => {
            Swal.close();
            
           
            if (parent_workflow_id) {
              
              Swal.fire({
                title: 'Workflow Complete',
                text: 'Would you like to view other available sub-workflows or return to the dashboard?',
                icon: 'success',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#28a745',
                confirmButtonText: 'Back to Sub-workflows',
                cancelButtonText: 'Go to Dashboard',
                reverseButtons: true
              }).then((result) => {
                if (result.isConfirmed) {
               
                  this.$store.dispatch('update_workflow_id', parent_workflow_id);
                  
            
                  this.mark_workflow_complete(workflow_id);
                 
                  this.$store.commit('clear_current_application');
                  
               
                  this.$router.push({ name: 'sub_workflow_page' });
                } else {
              
                  this.$store.commit('clear_workflow_id');
                  this.$store.commit('clear_current_application');
                  localStorage.removeItem('parent_workflow_id');
                  
                 
                  this.$router.push('/');
                }
              });
            } else {
            
              this.check_for_sub_workflows(workflow_id);
            }
          },
          error: (xhr) => {
            Swal.close();
            
            const error_msg = xhr.responseJSON?.message || 'Failed to complete the workflow.';
            Swal.fire({
              icon: 'error',
              title: 'Error Completing Workflow',
              text: error_msg,
              confirmButtonText: 'OK'
            });
          }
        });
      },

    route_to_current_service() {
      if (this.current_service) {
        this.$router.push({ name: this.current_service });
      }
    },

    fetch_previous_service() {
      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      const GET_PREVIOUS_SERVICE = `${BASE_URL}/verify_api/customer_management_api/get_workflow_previous_service/${this.workflow_id}/${this.service_id}/`;

      Swal.fire({
        text: 'Loading previous service...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      $.ajax({
        url: GET_PREVIOUS_SERVICE,
        method: 'GET',
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        success: (response) => {
          Swal.close();
          if (response) {
            if (response.service && response.service.service_id) {
              if (response.service.service_type === 'credit bureau') {
                this.current_service = response.context.flex_name
                this.route_to_current_service(this.current_service);
              }
              this.$store.commit('set_service_id', response.service.service_id);
            }
          }
        },
        error: () => {
          Swal.close();
          Swal.fire({
            text: 'Could not go back to previous service.',
            icon: 'warning'
          });
        }
      });
    },

    fetch_next_service() {
      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      const GET_NEXT_SERVICE = `${BASE_URL}/verify_api/customer_management_api/get_workflow_next_service/${this.workflow_id}/${this.service_id}/`;

      Swal.fire({
        text: 'Loading next service...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      $.ajax({
        url: GET_NEXT_SERVICE,
        method: 'GET',
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        success: (response) => {
          Swal.close();
          if (response) {
            if (response.service && response.service.service_id) {
              if (response.service.service_type === "credit bureau") {
                this.current_service = response.context.flex_name
                this.route_to_current_service(this.current_service);
              }
              this.$store.commit('set_service_id', response.service.service_id);
            }
          }
        },
        error: () => {
          Swal.close();
          Swal.fire({
            text: 'Could not go back to the next service.',
            icon: 'warning'
          });
        }
      });
    },

    completeService() {
        this.fetch_current_service();
    }
  }
};
